<style src="css/login.css" scoped></style>
<template>
  <div class="bgImg">
    <img class="loginLogo" src="../assets/common/logo02.jpg" alt="" />
    <div v-if="forgetStatus">
      <div class="inputBox">
        <div class="iconNumber"></div>
        <input
          type="text"
          autocomplete="off"
          placeholder="请输入工号或手机号"
          v-model="doctorPhone"
        />
      </div>
      <div class="inputBox">
        <div class="iconCard"></div>
        <input
          :type="type"
          autocomplete="new-password"
          placeholder="请输入密码"
          v-model="doctorPsw"
        />
        <div
          class="iconEye"
          :class="{ active: type === 'text' }"
          @click="show"
        ></div>
      </div>
      <div class="forgetBox" @click="forget">忘记密码？</div>
      <div class="loginBtn" @click="login">登 录</div>
    </div>
    <div v-else>
      <div class="inputBox">
        <div class="iconNumber"></div>
        <input
          type="text"
          autocomplete="off"
          placeholder="请输入工号或手机号"
          v-model="doctorPhone"
        />
      </div>
      <div class="inputBox codeBox">
        <div class="codeLeft">
          <div class="iconCard"></div>
          <input
            style="width: 2.2rem"
            autocomplete="new-password"
            placeholder="请输入验证码"
            v-model="code"
          />
        </div>
        <div class="getCode" v-if="status === 0" @click="getSmsAuthCode">
          获取验证码
        </div>
        <div class="getCode" v-if="status === 1">重新获取({{ num }})</div>
        <div class="getCode" v-if="status === 2" @click="getSmsAuthCode">
          重新获取
        </div>
      </div>
      <div class="inputBox">
        <div class="iconCard"></div>
        <input
          :type="type"
          autocomplete="new-password"
          placeholder="请重置密码"
          v-model="doctorPsw"
        />
        <div
          class="iconEye"
          :class="{ active: type === 'text' }"
          @click="show"
        ></div>
      </div>
      <div class="forgetBox" @click="forget">返回登录</div>
      <div class="loginBtn" @click="changeDoctorPsw">重置密码</div>
    </div>
  </div>
</template>
<script>
import { getSource, getSources } from "../api";
import topbar from "components/topbar";

import noMoreData from "components/no-more-data";

export default {
  data() {
    return {
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      doctorPhone: "",
      doctorPsw: "",
      code: "",
      openid: "",
      type: "password",
      forgetStatus: true,
      num: 59,
      status: 0,
      logo: localStorage.getItem("companyLogo")
        ? localStorage.getItem("companyLogo")
        : "logo.jpg",
    };
  },
  components: {
    topbar,
    noMoreData,
  },
  computed: {},
  methods: {
    forget() {
      this.doctorPsw = "";
      this.code = "";
      this.forgetStatus = !this.forgetStatus;
    },
    async changeDoctorPsw() {
      let data = await getSources(
        "/bear-scale/api/chatDoctor/changeDoctorPsw.json",
        {
          doctorPhone: this.doctorPhone,
          code: this.code,
          doctorPsw: this.doctorPsw,
        }
      );
      if (data.status === 0) {
        alert(`重置成功~`);
        this.forget();
      } else {
        alert(data.msg);
      }
    },
    async getSmsAuthCode() {
      if (!this.doctorPhone) {
        alert("请先输入工号或手机号");
        return;
      }
      let data = await getSources(
        "/bear-scale/api/scaleUserInfo/getSmsAuthCode.json",
        { userPhone: this.doctorPhone }
      );
      if (data.status === 0) {
        alert("发送成功");
        this.status = 1;
        this.num = 59;

        // this.$nextTick(() => {
        // 	this.$refs.code.focus()
        // })

        const that = this;

        setTimeout(function codeFormat() {
          that.num--;

          if (that.num) {
            setTimeout(codeFormat, 1000);
          } else {
            that.status = 2;
          }
        }, 1000);

        return;
      } else {
        alert(data.msg);
      }
    },
    show() {
      if (this.type == "password") {
        this.type = "text";
      } else {
        this.type = "password";
      }
    },
    loginSuccess() {
      if (this.$route.query.next) {
        //                    location.href =
        this.$router.replace(`${this.$route.query.next}`);
        //                    console.log(this.$route)
      } else {
        this.$router.replace(`/`);
      }
    },
    getCookie(key) {
      let cookieStr = document.cookie.split("; ");
      for (let i = 0; i < cookieStr.length; i++) {
        let tempArr = cookieStr[i].split("=");
        if (tempArr[0] == key) {
          return tempArr[1];
        }
      }
      return null;
    },
    setCookie: function (cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      console.info(cname + "=" + cvalue + "; " + expires);
      document.cookie = cname + "=" + cvalue + "; " + expires;
      console.info(document.cookie);
    },
    async login() {
      if (!this.doctorPhone) {
        alert("请输入用户名");
        return;
      }
      if (!this.doctorPsw) {
        alert("请输入密码");
        return;
      }
      let data = await getSources(
        "/bear-scale/api/chatDoctor/scaleDoctorLogin.json",
        { doctorPhone: this.doctorPhone, doctorPsw: this.doctorPsw }
      );
      if (data.status === 0) {
        this.$utils.storeLoginInfo(data)
        this.loginSuccess();
      } else {
        alert(data.msg);
      }
    },
    handle() {
      let aa = this.$route.query.next.slice(2);
      var url_ll = aa.split("&"),
        obj = {};
      url_ll.forEach((item, idx) => {
        var key = item.split("=")[0];
        var val = item.split("=")[1];
        obj[key] = val;
      });
      if (obj.id && obj.token) {
        this.forScaleUserLogin(obj.id, obj.token);
      }
    },
    async forScaleUserLogin(id, token) {
      let data = await getSources(
        "/bear-scale/api/scaleUserInfo/forScaleUserLogin.json",
        {
          id: id,
          token: token,
        }
      );
      if (data.status === 0) {
        localStorage.setItem("loginType", data.loginType);
        localStorage.setItem("companyLogo", data.companyLogo);
        // localStorage.setItem('token',this.token)
        // localStorage.setItem('id',this.id)
        this.logo = data.companyLogo;
      } else {
        alert(data.msg);
      }
    },
  },
  mounted() {
    if (
      localStorage.getItem("doctorPhone") &&
      localStorage.getItem("doctorPsw")
    ) {
      this.doctorPhone = localStorage.getItem("doctorPhone");
      this.doctorPsw = localStorage.getItem("doctorPsw");
    } else {
      // console.log("wu");
    }
    if (this.$route.query.next) {
      this.handle();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/login.vue